export const EMPLOYEE_SCALES = [
  { id: '1', name: '20人未満' },
  { id: '2', name: '20人以上100人未満' },
  { id: '3', name: '100人以上300人未満' },
  { id: '4', name: '300人以上500人未満' },
  { id: '5', name: '500人以上1000人未満' },
  { id: '6', name: '1000人以上3000人未満' },
  { id: '7', name: '3000人以上' },
];
